import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { mainListItems, SecondaryListItems } from "../../common/ListItems";
import CorporationTable from "../../containers/CorporationTable";
import { compose } from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import CreateCorporationModal from "../../containers/CreateCorporationModal";
import UpdateCorporationModal from "../../containers/UpdateCorporationModal";

import * as userActions from "../../actions/User";
import * as configActions from "../../actions/Config";
import * as CommunityActions from "../../actions/Communities";
import * as Constants from "../../../helpers/Constants";
import * as Strings from "./strings";

const drawerWidth = 240;

class Dashboard extends React.Component {
  state = {
    open: true,
    corp: {
      open: false,
      id: null
    }
  };

  componentDidMount() {
    const { history, user } = this.props;

    if (!user.token) {
      history.push("/");
    } else {
      this.props.tryGetCommunities(user.token);
    }
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, history } = this.props;

    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.root}>
          <AppBar
            position="absolute"
            className={classNames(
              classes.appBar,
              this.state.open && classes.appBarShift
            )}
            style={{ backgroundColor: "#289e64", boxShadow: "0px" }}
          >
            <Toolbar
              disableGutters={!this.state.open}
              className={classes.toolbar}
            >
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.handleDrawerOpen}
                className={classNames(
                  classes.menuButton,
                  this.state.open && classes.menuButtonHidden
                )}
              >
                <MenuIcon />
              </IconButton>
              <Typography
                variant="title"
                color="inherit"
                noWrap
                className={classes.title}
              >
                BRF:er
              </Typography>
            </Toolbar>
          </AppBar>
          <Drawer
            variant="permanent"
            classes={{
              paper: classNames(
                classes.drawerPaper,
                !this.state.open && classes.drawerPaperClose
              )
            }}
            open={this.state.open}
          >
            <div className={classes.toolbarIcon}>
              <IconButton onClick={this.handleDrawerClose}>
                <ChevronLeftIcon />
              </IconButton>
            </div>
            <Divider />
            <List>{mainListItems}</List>
            <Divider />
            <List>
              <SecondaryListItems
                onSignOut={() =>
                  this.props.showAlert(
                    Strings.default.SIGN_OUT,
                    Strings.default.SIGN_OUT_HEADER,
                    Constants.TWO_BUTTONS,
                    { title: Strings.default.NO, onPress: () => {} },
                    {
                      title: Strings.default.YES,
                      onPress: () => this.props.signOut()
                    }
                  )
                }
              />
            </List>
          </Drawer>
          <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <CorporationTable
              onClick={id =>
                this.setState({
                  corp: {
                    open: true,
                    id
                  }
                })
              }
            />
          </main>
        </div>
        {this.state.corp.open ? (
          <UpdateCorporationModal
            id={this.state.corp.id}
            onClose={() => this.setState({ corp: { id: null, open: false } })}
          />
        ) : null}
        <CreateCorporationModal />
      </React.Fragment>
    );
  }
}

const styles = theme => ({
  root: {
    display: "flex"
  },
  toolbar: {
    paddingRight: 24 // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36
  },
  menuButtonHidden: {
    display: "none"
  },
  title: {
    flexGrow: 1
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing.unit * 9
    }
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: "100vh",
    overflow: "auto"
  },
  chartContainer: {
    marginLeft: -22
  }
});

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps({ user }) {
  return { user };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...userActions, ...CommunityActions },
    dispatch
  );
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/index.js